import { useEffect, useState } from 'react';

import { useUserAgent } from '../common';

/**
 * 브릿지를 통해 주소 검색 화면으로 이동하는 커스텀훅
 * @remarks iOS 웹뷰에서만 사용합니다.
 */
export const useMoveToSearchAddress = () => {
  const { isIos } = useUserAgent();
  const [searchData, setSearchData] = useState<{ address: string; zonecode: string } | null>(null);

  const requestAppSearchAddress = () => {
    if (!isIos) {
      return;
    }

    const params = JSON.stringify({
      title: '주소 검색',
    });
    window.webkit?.messageHandlers.openSearchAddress?.postMessage(params);
  };

  const resetSearchData = () => {
    setSearchData(null);
  };

  useEffect(() => {
    window.onAddressData = (data: string) => {
      if (!isIos) {
        return;
      }

      try {
        const { address, zonecode } = JSON.parse(data);
        if (address && zonecode) {
          setSearchData({ address, zonecode });
        }
      } catch {
        setSearchData(null);
      }
    };

    return () => {
      window.onAddressData = null;
    };
  }, []);

  return {
    requestAppSearchAddress,
    resetSearchData,
    searchData,
  };
};
